import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import RuleSetQuestion from './RuleSetQuestion';
import { Button, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@material-ui/core';
import FeeAnswersViewModel from '../../ViewModels/FeeAnswersViewModel';
import Alert from '@material-ui/lab/Alert';

const styles = (theme: Theme) => createStyles({
    empty: {},
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    buttonItem: {
        marginTop: theme.spacing(2),
    },
    button: {
    },
    multiSelect: {
        marginLeft: "10px"
    }
});


const storedMessages =
    [
        // 0
        [

        ],
        // ruleset1
        [
            {
                case: 0,
                studentMessage: "Government Funded - No Fees",
                hcukMessage: "16-18 Gov Funded",
            },
        ],
        // ruleset2
        [
            {
                case: 0,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
        ],
        // ruleset3
        [
            {
                case: 1,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 2,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Maths and English",
            },

        ],
        // ruleset4
        [
            {
                case: 2,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Low Income",
            },
            {
                case: 3,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 6,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 7,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 9,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 12,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 13,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 14,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
        ],
        // ruleset5
        [
            {
                case: 2,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Low Income",
            },
            {
                case: 3,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 6,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 7,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 9,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 12,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 13,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 14,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 15,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Progression",
            },
        ],
        // ruleset6
        [
            {
                case: 2,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Low Income",
            },
            {
                case: 3,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 6,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 7,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 9,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 12,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 13,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 14,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 15,
                studentMessage: "You don�t qualify for a fee waiver and there are no fee pay options. Please wait to be contacted by a member of our enrolment team.",
                hcukMessage: "Switch AIM � No Option For Fee Pay",
            },
        ],
        // ruleset7
        [
            {
                case: 2,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Low Income",
            },
            {
                case: 3,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 6,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 7,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 9,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 12,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 13,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 14,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 15,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Progression",
            },
        ],
        // ruleset8
        [
            {
                case: 4,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Low Income",
            },
            {
                case: 6,
                studentMessage: "Your course should be funded by an Advanced Learner Loan",
                hcukMessage: "Advanced Learner Loan",
            },
            {
                case: 7,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 10,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 12,
                studentMessage: "Your course should be funded by an Advanced Learner Loan",
                hcukMessage: "Advanced Learner Loan",
            },
            {
                case: 13,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 15,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 17,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 19,
                studentMessage: "Your course should be funded by an Advanced Learner Loan",
                hcukMessage: "Advanced Learner Loan",
            },
            {
                case: 20,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 22,
                studentMessage: "Your course should be funded by an Advanced Learner Loan",
                hcukMessage: "Advanced Learner Loan",
            },
            {
                case: 23,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 24,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = L3 NSF Waiver",
            },

        ],
        // ruleset9
        [
            {
                case: 4,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = L3 NSF Waiver",
            },
            {
                case: 5,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 8,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 9,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 11,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 13,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 14,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 15,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 16,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Progression",
            },
        ],
        // ruleset10
        [
            {
                case: 1,
                studentMessage: "Your course should be funded by an Advanced Learner Loan",
                hcukMessage: "Advanced Learner Loan",
            },
            {
                case: 2,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
        ],
        // ruleset11
        [
            {
                case: 2,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = L3 Waiver",
            },
            {
                case: 3,
                studentMessage: "Your course should be funded by an Advanced Learner Loan",
                hcukMessage: "Advanced Learner Loan",
            },
            {
                case: 4,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
        ],
        // ruleset12
        [
            {
                case: 0,
                studentMessage: "You don�t qualify for a fee waiver and there are no fee pay options. Please wait to be contacted by a member of our enrolment team.",
                hcukMessage: "Switch AIM � No Options For Fee Pay",
            },
        ],
        // ruleset13
        [
            {
                case: 4,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Low Income",
            },
            {
                case: 6,
                studentMessage: "Your course should be funded by an Advanced Learner Loan",
                hcukMessage: "Advanced Learner Loan",
            },
            {
                case: 7,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 10,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 12,
                studentMessage: "Your course should be funded by an Advanced Learner Loan",
                hcukMessage: "Advanced Learner Loan",
            },
            {
                case: 13,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 15,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 17,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Benefit Waiver",
            },
            {
                case: 19,
                studentMessage: "Your course should be funded by an Advanced Learner Loan",
                hcukMessage: "Advanced Learner Loan",
            },
            {
                case: 20,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 22,
                studentMessage: "Your course should be funded by an Advanced Learner Loan",
                hcukMessage: "Advanced Learner Loan",
            },
            {
                case: 23,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 24,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = L3 Entitlement Waiver",
            },

        ],
        // ruleset14
        [
            {
                case: 1,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Low Income",
            },
            {
                case: 2,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
        ],
        // ruleset15
        [
            {
                case: 1,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Low Income",
            },
            {
                case: 3,
                studentMessage: "Your course should be funded by an Advanced Learner Loan",
                hcukMessage: "Advanced Learner Loan",
            },
            {
                case: 4,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
        ],
        // ruleset16
        [
            {
                case: 2,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Low Income",
            },
            {
                case: 3,
                studentMessage: "Course Fees Apply",
                hcukMessage: "Fee Payer",
            },
            {
                case: 4,
                studentMessage: "You appear to qualify for a fee waiver",
                hcukMessage: "Payment Waiver = Progression",
            },

        ],
    ];

interface IRuleSetProps {
    model: FeeAnswersViewModel;
    index: number;
    ruleSetId: number;
    updateAnswers: (index, value) => void;
    setFeesAnswers: (index, studentAnswer: string, hcukAnswer: string) => void;
    resetFeesQuestions: (index) => void;
    setFeeAcceptance: (index, acceptance: boolean) => void;
    courseLevel: string;
    courseFees: string;
}

interface IRuleSetState {
    questionState: number;

    questionADisabled: boolean;
    questionBDisabled: boolean;
    questionCDisabled: boolean;
    questionDDisabled: boolean;
    questionEDisabled: boolean;
    questionFDisabled: boolean;
    questionGDisabled: boolean;
    questionHDisabled: boolean;
    questionIDisabled: boolean;
    questionJDisabled: boolean;
    questionKDisabled: boolean;
    questionLDisabled: boolean;

    displayAcceptance: boolean;

    displayResetButton: boolean;
}

export class FeeRuleSetsAdditional extends Component<IRuleSetProps & WithStyles<typeof styles>, IRuleSetState> {




    constructor(props) {
        super(props);

        this.state = {
            questionState: 0,
            questionADisabled: false,
            questionBDisabled: false,
            questionCDisabled: false,
            questionDDisabled: false,
            questionEDisabled: false,
            questionFDisabled: false,
            questionGDisabled: false,
            questionHDisabled: false,
            questionIDisabled: false,
            questionJDisabled: false,
            questionKDisabled: false,
            questionLDisabled: false,
            displayAcceptance: false,
            displayResetButton: true,

        };
    }

    public componentDidMount() {
        if (this.props.ruleSetId == 1 || this.props.ruleSetId == 2 || this.props.ruleSetId == 12) {
            this.setState({ displayAcceptance: true, displayResetButton: false });

            this.props.setFeesAnswers(this.props.index, storedMessages[this.props.ruleSetId][0].studentMessage, storedMessages[this.props.ruleSetId][0].hcukMessage);
        }
    }

    private handleQuestionChange = (event, newState) => {
        this.props.updateAnswers(this.props.index, event);
        var message = storedMessages[this.props.ruleSetId].find(e => e.case === newState);

        this.props.setFeesAnswers(this.props.index, message === undefined ? "" : message?.studentMessage, message === undefined ? "" : message?.hcukMessage);

        this.setState({
            questionState: newState,
            displayAcceptance: (message !== undefined)
        });
    }

    private handleAcceptanceChange = (event) => {
        this.props.updateAnswers(this.props.index, event);
    }

    private resetAnswers = () => {
        this.props.resetFeesQuestions(this.props.index);
        this.setState({
            questionState: 0,
            questionADisabled: false,
            questionBDisabled: false,
            questionCDisabled: false,
            questionDDisabled: false,
            questionEDisabled: false,
            questionFDisabled: false,
            questionGDisabled: false,
            questionHDisabled: false,
            questionIDisabled: false,
            questionJDisabled: false,
            questionKDisabled: false,
            questionLDisabled: false,
            displayAcceptance: false,

        });
    }

    private disableQuestionA = () => {
        this.setState({ questionADisabled: true });
    }
    private disableQuestionB = () => {
        this.setState({ questionBDisabled: true });
    }
    private disableQuestionC = () => {
        this.setState({ questionCDisabled: true });
    }
    private disableQuestionD = () => {
        this.setState({ questionDDisabled: true });
    }
    private disableQuestionE = () => {
        this.setState({ questionEDisabled: true });
    }
    private disableQuestionF = () => {
        this.setState({ questionFDisabled: true });
    }
    private disableQuestionG = () => {
        this.setState({ questionGDisabled: true });
    }
    private disableQuestionH = () => {
        this.setState({ questionHDisabled: true });
    }
    private disableQuestionI = () => {
        this.setState({ questionIDisabled: true });
    }
    private disableQuestionJ = () => {
        this.setState({ questionJDisabled: true });
    }
    private disableQuestionK = () => {
        this.setState({ questionKDisabled: true });
    }
    private disableQuestionL = () => {
        this.setState({ questionLDisabled: true });
    }

    public render() {
        var classes = this.props.classes;

        let feePayerMessage = (<Grid item xs={12} ><Alert severity="info"><b>Course Fees Apply</b></Alert></Grid>);
        let advancedLearnerMessage = (<Grid item xs={12}><Alert severity="info"><b>Your course should be funded by an Advanced Learner Loan</b></Alert></Grid>);
        let waiverMessage = (<Grid item xs={12} ><Alert severity="info"><b>You appear to qualify for a fee waiver</b></Alert></Grid>);
        let noOptionsMessage = (<Grid item xs={12} ><Alert severity="info"><b>You don�t qualify for a fee waiver and there are no fee pay options. Please wait to be contacted by a member of our enrolment team.</b></Alert></Grid>);
        let govFundedMessage = (<Grid item xs={12} ><Alert severity="info"><b>Government Funded - No Fees</b></Alert></Grid>);


        const elements =
            [
                // 0
                [

                ],
                // ruleset1
                [
                    {
                        case: 0,
                        cases: [0],
                        element: (govFundedMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset2
                [
                    {
                        case: 0,
                        cases: [0],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset3
                [
                    {
                        case: 0,
                        cases: [0, 1, 2],
                        element: (/* Question A */<RuleSetQuestion key={0} trueQuestionState={1} falseQuestionState={2} name="mandeGradeCOrAbove" value={this.props.model.mandeGradeCOrAbove} question="Have you already achieved this qualification or achieved a Grade C/4 or above at GCSE or equivalent in this subject?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionA} disabled={this.state.questionBDisabled} />),

                    },
                    {
                        case: 1,
                        cases: [1],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 2,
                        cases: [2],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset4
                [
                    {
                        case: 0,
                        cases: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question D */<RuleSetQuestion key={1} trueQuestionState={1} falseQuestionState={4} name="areYouWorking" value={this.props.model.areYouWorking} question="Are You Working?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionD} disabled={this.state.questionDDisabled} />)
                    },
                    {
                        case: 1,
                        cases: [1, 2, 3],
                        element: (/* Question E */<RuleSetQuestion key={2} trueQuestionState={2} falseQuestionState={3} name="earnLessThan17K" value={this.props.model.earnLessThan17K} question={`Do you earn less than ${this.props.courseFees} annual gross ( before tax & NI ) salary?`} handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionE} disabled={this.state.questionEDisabled} />)
                    },
                    {
                        case: 4,
                        cases: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question F */<RuleSetQuestion key={3} trueQuestionState={5} falseQuestionState={8} name="universalCredit" value={this.props.model.universalCredit} question="Do you claim Universal Credit, disregarding Universal Credit and other benefits, and earn less than the relevant monthly threshold from paid employment?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionF} disabled={this.state.questionFDisabled} />)
                    },
                    {
                        case: 5,
                        cases: [5, 6, 7],
                        element: (/* Question G */<RuleSetQuestion key={4} trueQuestionState={6} falseQuestionState={7} name="universalCreditLowerIncome" value={this.props.model.universalCreditLowerIncome} question="Are you claiming an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionG} disabled={this.state.questionGDisabled} />)
                    },
                    {
                        case: 8,
                        cases: [8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question H */<RuleSetQuestion key={5} trueQuestionState={9} falseQuestionState={10} name="jsaOrEsa" value={this.props.model.jsaOrEsa} question="Are you claiming Job Seekers Allowance (JSA) or Employment and Support Allowance (ESA)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionH} disabled={this.state.questionHDisabled} />)
                    },
                    {
                        case: 10,
                        cases: [10, 11, 12, 13, 14],
                        element: (/* Question I */<RuleSetQuestion key={6} trueQuestionState={11} falseQuestionState={14} name="otherBenefitsLowIncome" value={this.props.model.otherBenefitsLowIncome} question="Are you claiming other Benefits with an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionI} disabled={this.state.questionIDisabled} />)
                    },
                    {
                        case: 11,
                        cases: [11, 12, 13],
                        element: (/* Question K */<RuleSetQuestion key={7} trueQuestionState={12} falseQuestionState={13} name="sustainable" value={this.props.model.sustainable} question="Do you want to work or progress into more sustainable employment?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionK} disabled={this.state.questionKDisabled} />)
                    },
                    {
                        case: 2,
                        cases: [2],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 3,
                        cases: [3],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 6,
                        cases: [6],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 7,
                        cases: [7],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 9,
                        cases: [9],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 12,
                        cases: [12],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 13,
                        cases: [13],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 14,
                        cases: [14],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset5
                [
                    {
                        case: 0,
                        cases: [0, 20, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                        element: (/* Question B */ <RuleSetQuestion key={8} trueQuestionState={20} falseQuestionState={15} name="completedL2OrAbove" value={this.props.model.completedL2OrAbove} question="Have you already completed a Full Level 2 or higher?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionB} disabled={this.state.questionBDisabled} />)
                    },
                    {
                        case: 20,
                        cases: [20, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question D */<RuleSetQuestion key={9} trueQuestionState={1} falseQuestionState={4} name="areYouWorking" value={this.props.model.areYouWorking} question="Are You Working?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionD} disabled={this.state.questionDDisabled} />)
                    },
                    {
                        case: 1,
                        cases: [1, 2, 3],
                        element: (/* Question E */<RuleSetQuestion key={10} trueQuestionState={2} falseQuestionState={3} name="earnLessThan17K" value={this.props.model.earnLessThan17K} question={`Do you earn less than ${this.props.courseFees} annual gross ( before tax & NI ) salary?`} handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionE} disabled={this.state.questionEDisabled} />)
                    },
                    {
                        case: 4,
                        cases: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question F */<RuleSetQuestion key={11} trueQuestionState={5} falseQuestionState={8} name="universalCredit" value={this.props.model.universalCredit} question="Do you claim Universal Credit, disregarding Universal Credit and other benefits, and earn less than the relevant monthly threshold from paid employment?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionF} disabled={this.state.questionFDisabled} />)
                    },
                    {
                        case: 5,
                        cases: [5, 6, 7],
                        element: (/* Question G */<RuleSetQuestion key={12} trueQuestionState={6} falseQuestionState={7} name="universalCreditLowerIncome" value={this.props.model.universalCreditLowerIncome} question="Are you claiming an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionG} disabled={this.state.questionGDisabled} />)
                    },
                    {
                        case: 8,
                        cases: [8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question H */<RuleSetQuestion key={13} trueQuestionState={9} falseQuestionState={10} name="jsaOrEsa" value={this.props.model.jsaOrEsa} question="Are you claiming Job Seekers Allowance (JSA) or Employment and Support Allowance (ESA)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionH} disabled={this.state.questionHDisabled} />)
                    },
                    {
                        case: 10,
                        cases: [10, 11, 12, 13, 14],
                        element: (/* Question I */<RuleSetQuestion key={14} trueQuestionState={11} falseQuestionState={14} name="otherBenefitsLowIncome" value={this.props.model.otherBenefitsLowIncome} question="Are you claiming other Benefits with an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionI} disabled={this.state.questionIDisabled} />)
                    },
                    {
                        case: 11,
                        cases: [11, 12, 13],
                        element: (/* Question K */<RuleSetQuestion key={15} trueQuestionState={12} falseQuestionState={13} name="sustainable" value={this.props.model.sustainable} question="Do you want to work or progress into more sustainable employment?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionK} disabled={this.state.questionKDisabled} />)
                    },
                    {
                        case: 2,
                        cases: [2],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 3,
                        cases: [3],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 6,
                        cases: [6],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 7,
                        cases: [7],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 9,
                        cases: [9],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 12,
                        cases: [12],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 13,
                        cases: [13],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 14,
                        cases: [14],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 15,
                        cases: [15],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset6
                [
                    {
                        case: 0,
                        cases: [0, 20, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                        element: (/* Question B */ <RuleSetQuestion key={16} trueQuestionState={20} falseQuestionState={15} name="completedL2OrAbove" value={this.props.model.completedL2OrAbove} question="Have you already completed a Full Level 2 or higher?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionB} disabled={this.state.questionBDisabled} />)
                    },
                    {
                        case: 20,
                        cases: [20, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question D */<RuleSetQuestion key={17} trueQuestionState={1} falseQuestionState={4} name="areYouWorking" value={this.props.model.areYouWorking} question="Are You Working?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionD} disabled={this.state.questionDDisabled} />)
                    },
                    {
                        case: 1,
                        cases: [1, 2, 3],
                        element: (/* Question E */<RuleSetQuestion key={18} trueQuestionState={2} falseQuestionState={3} name="earnLessThan17K" value={this.props.model.earnLessThan17K} question={`Do you earn less than ${this.props.courseFees} annual gross ( before tax & NI ) salary?`} handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionE} disabled={this.state.questionEDisabled} />)
                    },
                    {
                        case: 4,
                        cases: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question F */<RuleSetQuestion key={19} trueQuestionState={5} falseQuestionState={8} name="universalCredit" value={this.props.model.universalCredit} question="Do you claim Universal Credit, disregarding Universal Credit and other benefits, and earn less than the relevant monthly threshold from paid employment?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionF} disabled={this.state.questionFDisabled} />)
                    },
                    {
                        case: 5,
                        cases: [5, 6, 7],
                        element: (/* Question G */<RuleSetQuestion key={20} trueQuestionState={6} falseQuestionState={7} name="universalCreditLowerIncome" value={this.props.model.universalCreditLowerIncome} question="Are you claiming an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionG} disabled={this.state.questionGDisabled} />)
                    },
                    {
                        case: 8,
                        cases: [8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question H */<RuleSetQuestion key={21} trueQuestionState={9} falseQuestionState={10} name="jsaOrEsa" value={this.props.model.jsaOrEsa} question="Are you claiming Job Seekers Allowance (JSA) or Employment and Support Allowance (ESA)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionH} disabled={this.state.questionHDisabled} />)
                    },
                    {
                        case: 10,
                        cases: [10, 11, 12, 13, 14],
                        element: (/* Question I */<RuleSetQuestion key={22} trueQuestionState={11} falseQuestionState={14} name="otherBenefitsLowIncome" value={this.props.model.otherBenefitsLowIncome} question="Are you claiming other Benefits with an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionI} disabled={this.state.questionIDisabled} />)
                    },
                    {
                        case: 11,
                        cases: [11, 12, 13],
                        element: (/* Question K */<RuleSetQuestion key={23} trueQuestionState={12} falseQuestionState={13} name="sustainable" value={this.props.model.sustainable} question="Do you want to work or progress into more sustainable employment?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionK} disabled={this.state.questionKDisabled} />)
                    },
                    {
                        case: 2,
                        cases: [2],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 3,
                        cases: [3],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 6,
                        cases: [6],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 7,
                        cases: [7],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 9,
                        cases: [9],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 12,
                        cases: [12],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 13,
                        cases: [13],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 14,
                        cases: [14],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 15,
                        cases: [15],
                        element: (noOptionsMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset7
                [
                    {
                        case: 0,
                        cases: [0, 20, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                        element: (/* Question B */ <RuleSetQuestion key={24} trueQuestionState={20} falseQuestionState={15} name="completedL2OrAbove" value={this.props.model.completedL2OrAbove} question="Have you already completed a Full Level 2 or higher?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionB} disabled={this.state.questionBDisabled} />)
                    },
                    {
                        case: 20,
                        cases: [20, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question D */<RuleSetQuestion key={25} trueQuestionState={1} falseQuestionState={4} name="areYouWorking" value={this.props.model.areYouWorking} question="Are You Working?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionD} disabled={this.state.questionDDisabled} />)
                    },
                    {
                        case: 1,
                        cases: [1, 2, 3],
                        element: (/* Question E */<RuleSetQuestion key={26} trueQuestionState={2} falseQuestionState={3} name="earnLessThan17K" value={this.props.model.earnLessThan17K} question={`Do you earn less than ${this.props.courseFees} annual gross ( before tax & NI ) salary?`} handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionE} disabled={this.state.questionEDisabled} />)
                    },
                    {
                        case: 4,
                        cases: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question F */<RuleSetQuestion key={27} trueQuestionState={5} falseQuestionState={8} name="universalCredit" value={this.props.model.universalCredit} question="Do you claim Universal Credit, disregarding Universal Credit and other benefits, and earn less than the relevant monthly threshold from paid employment?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionF} disabled={this.state.questionFDisabled} />)
                    },
                    {
                        case: 5,
                        cases: [5, 6, 7],
                        element: (/* Question G */<RuleSetQuestion key={28} trueQuestionState={6} falseQuestionState={7} name="universalCreditLowerIncome" value={this.props.model.universalCreditLowerIncome} question="Are you claiming an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionG} disabled={this.state.questionGDisabled} />)
                    },
                    {
                        case: 8,
                        cases: [8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question H */<RuleSetQuestion key={29} trueQuestionState={9} falseQuestionState={10} name="jsaOrEsa" value={this.props.model.jsaOrEsa} question="Are you claiming Job Seekers Allowance (JSA) or Employment and Support Allowance (ESA)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionH} disabled={this.state.questionHDisabled} />)
                    },
                    {
                        case: 10,
                        cases: [10, 11, 12, 13, 14],
                        element: (/* Question I */<RuleSetQuestion key={30} trueQuestionState={11} falseQuestionState={14} name="otherBenefitsLowIncome" value={this.props.model.otherBenefitsLowIncome} question="Are you claiming other Benefits with an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionI} disabled={this.state.questionIDisabled} />)
                    },
                    {
                        case: 11,
                        cases: [11, 12, 13],
                        element: (/* Question K */<RuleSetQuestion key={31} trueQuestionState={12} falseQuestionState={13} name="sustainable" value={this.props.model.sustainable} question="Do you want to work or progress into more sustainable employment?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionK} disabled={this.state.questionKDisabled} />)
                    },
                    {
                        case: 2,
                        cases: [2],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 3,
                        cases: [3],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 6,
                        cases: [6],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 7,
                        cases: [7],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 9,
                        cases: [9],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 12,
                        cases: [12],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 13,
                        cases: [13],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 14,
                        cases: [14],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 15,
                        cases: [15],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset8
                [
                    {
                        case: 0,
                        cases: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
                        element: (/* Question B */ <RuleSetQuestion key={800} trueQuestionState={1} falseQuestionState={24} name="completedL2OrAbove" value={this.props.model.completedL2OrAbove} question="Have you already completed a Full Level 3 or higher?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionB} disabled={this.state.questionBDisabled} />),

                    },
                    {
                        case: 1,
                        cases: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
                        element: (/* Question L */<RuleSetQuestion key={801} trueQuestionState={2} falseQuestionState={21} name="achBeforeApril" value={this.props.model.achBeforeApril} question="Was this achieved/completed before the 1st April 2021?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionL} disabled={this.state.questionLDisabled} />),

                    },
                    {
                        case: 2,
                        cases: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                        element: (/* Question D */<RuleSetQuestion key={802} trueQuestionState={3} falseQuestionState={8} name="areYouWorking" value={this.props.model.areYouWorking} question="Are You Working?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionD} disabled={this.state.questionDDisabled} />),

                    },
                    {
                        case: 3,
                        cases: [3, 4, 5, 6, 7],
                        element: (/* Question E */<RuleSetQuestion key={803} trueQuestionState={4} falseQuestionState={5} name="earnLessThan17K" value={this.props.model.earnLessThan17K} question={`Do you earn less than ${this.props.courseFees} annual gross ( before tax & NI ) salary?`} handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionE} disabled={this.state.questionEDisabled} />),

                    },
                    {
                        case: 4,
                        cases: [4],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 5,
                        cases: [5, 6, 7],
                        element: (/* Question J */<RuleSetQuestion key={804} trueQuestionState={5} falseQuestionState={7} name="haveYouAppliedLl" value={this.props.model.haveYouAppliedLl} question="Have you applied for, or planning to apply for an Adult Loan?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionJ} disabled={this.state.questionJDisabled} />),

                    },
                    {
                        case: 6,
                        cases: [6],
                        element: (advancedLearnerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 7,
                        cases: [7],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 8,
                        cases: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                        element: (/* Question F */<RuleSetQuestion key={805} trueQuestionState={9} falseQuestionState={14} name="universalCredit" value={this.props.model.universalCredit} question="Do you claim Universal Credit, disregarding Universal Credit and other benefits, and earn less than the relevant monthly threshold from paid employment?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionF} disabled={this.state.questionFDisabled} />),

                    },
                    {
                        case: 9,
                        cases: [9, 10, 11, 12, 13],
                        element: (/* Question G */<RuleSetQuestion key={806} trueQuestionState={10} falseQuestionState={11} name="universalCreditLowerIncome" value={this.props.model.universalCreditLowerIncome} question="Are you claiming an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionG} disabled={this.state.questionGDisabled} />),

                    },
                    {
                        case: 10,
                        cases: [10],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 11,
                        cases: [11, 12, 13],
                        element: (/* Question J */<RuleSetQuestion key={807} trueQuestionState={12} falseQuestionState={13} name="haveYouAppliedLl" value={this.props.model.haveYouAppliedLl} question="Have you applied for, or planning to apply for an Adult Loan?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionJ} disabled={this.state.questionJDisabled} />),

                    },
                    {
                        case: 12,
                        cases: [12],
                        element: (advancedLearnerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 13,
                        cases: [13],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 14,
                        cases: [14, 15, 16, 17, 18, 19, 20],
                        element: (/* Question H */<RuleSetQuestion key={808} trueQuestionState={15} falseQuestionState={16} name="jsaOrEsa" value={this.props.model.jsaOrEsa} question="Are you claiming Job Seekers Allowance (JSA) or Employment and Support Allowance (ESA)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionH} disabled={this.state.questionHDisabled} />),

                    },
                    {
                        case: 15,
                        cases: [15],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 16,
                        cases: [16, 17, 18, 19, 20],
                        element: (/* Question I */<RuleSetQuestion key={809} trueQuestionState={17} falseQuestionState={18} name="otherBenefitsLowIncome" value={this.props.model.otherBenefitsLowIncome} question="Are you claiming other Benefits with an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionI} disabled={this.state.questionIDisabled} />),

                    },
                    {
                        case: 17,
                        cases: [17],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 18,
                        cases: [18, 19, 29],
                        element: (/* Question J */<RuleSetQuestion key={810} trueQuestionState={19} falseQuestionState={20} name="haveYouAppliedLl" value={this.props.model.haveYouAppliedLl} question="Have you applied for, or planning to apply for an Adult Loan?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionJ} disabled={this.state.questionJDisabled} />),

                    },
                    {
                        case: 19,
                        cases: [19],
                        element: (advancedLearnerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 20,
                        cases: [20],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 21,
                        cases: [21, 22, 23],
                        element: (/* Question J */<RuleSetQuestion key={811} trueQuestionState={22} falseQuestionState={23} name="haveYouAppliedLl" value={this.props.model.haveYouAppliedLl} question="Have you applied for, or planning to apply for an Adult Loan?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionJ} disabled={this.state.questionJDisabled} />),

                    },
                    {
                        case: 22,
                        cases: [22],
                        element: (advancedLearnerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 23,
                        cases: [23],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 24,
                        cases: [24],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset9
                [
                    {
                        case: 0,
                        cases: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
                        element: (/* Question B */ <RuleSetQuestion key={900} trueQuestionState={1} falseQuestionState={16} name="completedL2OrAbove" value={this.props.model.completedL2OrAbove} question="Have you already completed a Full Level 3 or higher?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionB} disabled={this.state.questionBDisabled} />),

                    },
                    {
                        case: 1,
                        cases: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                        element: (/* Question L */<RuleSetQuestion key={901} trueQuestionState={2} falseQuestionState={15} name="achBeforeApril" value={this.props.model.achBeforeApril} question="Was this achieved/completed before the 1st April 2021?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionL} disabled={this.state.questionLDisabled} />),

                    },
                    {
                        case: 2,
                        cases: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question D */<RuleSetQuestion key={902} trueQuestionState={3} falseQuestionState={6} name="areYouWorking" value={this.props.model.areYouWorking} question="Are You Working?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionD} disabled={this.state.questionDDisabled} />),

                    },
                    {
                        case: 3,
                        cases: [3, 4, 5],
                        element: (/* Question E */<RuleSetQuestion key={903} trueQuestionState={4} falseQuestionState={5} name="earnLessThan17K" value={this.props.model.earnLessThan17K} question={`Do you earn less than ${this.props.courseFees} annual gross ( before tax & NI ) salary?`} handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionE} disabled={this.state.questionEDisabled} />),

                    },
                    {
                        case: 4,
                        cases: [4],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 5,
                        cases: [5],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 6,
                        cases: [6, 7, 8, 9, 10, 11, 12, 13, 14],
                        element: (/* Question F */<RuleSetQuestion key={904} trueQuestionState={7} falseQuestionState={10} name="universalCredit" value={this.props.model.universalCredit} question="Do you claim Universal Credit, disregarding Universal Credit and other benefits, and earn less than the relevant monthly threshold from paid employment?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionF} disabled={this.state.questionFDisabled} />)
                    },
                    {
                        case: 7,
                        cases: [7, 8, 9],
                        element: (/* Question G */<RuleSetQuestion key={905} trueQuestionState={8} falseQuestionState={9} name="universalCreditLowerIncome" value={this.props.model.universalCreditLowerIncome} question="Are you claiming an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionG} disabled={this.state.questionGDisabled} />)
                    },
                    {
                        case: 8,
                        cases: [8],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 9,
                        cases: [9],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 10,
                        cases: [10, 11, 12, 13, 14],
                        element: (/* Question H */<RuleSetQuestion key={906} trueQuestionState={11} falseQuestionState={12} name="jsaOrEsa" value={this.props.model.jsaOrEsa} question="Are you claiming Job Seekers Allowance (JSA) or Employment and Support Allowance (ESA)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionH} disabled={this.state.questionHDisabled} />)
                    },
                    {
                        case: 11,
                        cases: [11],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 12,
                        cases: [12, 13, 14],
                        element: (/* Question I */<RuleSetQuestion key={907} trueQuestionState={13} falseQuestionState={14} name="otherBenefitsLowIncome" value={this.props.model.otherBenefitsLowIncome} question="Are you claiming other Benefits with an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionI} disabled={this.state.questionIDisabled} />)
                    },
                    {
                        case: 13,
                        cases: [13],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 14,
                        cases: [14],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 15,
                        cases: [15],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 16,
                        cases: [16],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset10
                [
                    {
                        case: 0,
                        cases: [0, 1, 2],
                        element: (/* Question J */<RuleSetQuestion key={35} trueQuestionState={1} falseQuestionState={2} name="haveYouAppliedLl" value={this.props.model.haveYouAppliedLl} question="Have you applied for, or planning to apply for an Adult Loan?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionJ} disabled={this.state.questionJDisabled} />),

                    },
                    {
                        case: 1,
                        cases: [1],
                        element: (advancedLearnerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 2,
                        cases: [2],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset11
                [
                    {
                        case: 0,
                        cases: [0, 1, 2, 3, 4],
                        element: (/* Question C */<RuleSetQuestion key={36} trueQuestionState={1} falseQuestionState={2} name="completedCourseLevelOrAbove" value={this.props.model.completedCourseLevelOrAbove} question={"Have you already completed a Full " + this.props.courseLevel + " or higher?"} handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionC} disabled={this.state.questionCDisabled} />),

                    },

                    {
                        case: 1,
                        cases: [1, 3, 4],
                        element: (/* Question J */<RuleSetQuestion key={37} trueQuestionState={3} falseQuestionState={4} name="haveYouAppliedLl" value={this.props.model.haveYouAppliedLl} question="Have you applied for, or planning to apply for an Adult Loan?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionJ} disabled={this.state.questionJDisabled} />)
                    },
                    {
                        case: 2,
                        cases: [2],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 3,
                        cases: [3],
                        element: (advancedLearnerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 4,
                        cases: [4],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset12
                [
                    {
                        case: 0,
                        cases: [0],
                        element: (noOptionsMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset13
                [
                    {
                        case: 0,
                        cases: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
                        element: (/* Question B */ <RuleSetQuestion key={800} trueQuestionState={1} falseQuestionState={24} name="completedL2OrAbove" value={this.props.model.completedL2OrAbove} question="Have you already completed a Full Level 3 or higher?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionB} disabled={this.state.questionBDisabled} />),

                    },
                    {
                        case: 1,
                        cases: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
                        element: (/* Question L */<RuleSetQuestion key={801} trueQuestionState={2} falseQuestionState={21} name="achBeforeApril" value={this.props.model.achBeforeApril} question="Was this achieved/completed before the 1st April 2021?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionL} disabled={this.state.questionLDisabled} />),

                    },
                    {
                        case: 2,
                        cases: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                        element: (/* Question D */<RuleSetQuestion key={802} trueQuestionState={3} falseQuestionState={8} name="areYouWorking" value={this.props.model.areYouWorking} question="Are You Working?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionD} disabled={this.state.questionDDisabled} />),

                    },
                    {
                        case: 3,
                        cases: [3, 4, 5, 6, 7],
                        element: (/* Question E */<RuleSetQuestion key={803} trueQuestionState={4} falseQuestionState={5} name="earnLessThan17K" value={this.props.model.earnLessThan17K} question={`Do you earn less than ${this.props.courseFees} annual gross ( before tax & NI ) salary?`} handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionE} disabled={this.state.questionEDisabled} />),

                    },
                    {
                        case: 4,
                        cases: [4],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 5,
                        cases: [5, 6, 7],
                        element: (/* Question J */<RuleSetQuestion key={804} trueQuestionState={5} falseQuestionState={7} name="haveYouAppliedLl" value={this.props.model.haveYouAppliedLl} question="Have you applied for, or planning to apply for an Adult Loan?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionJ} disabled={this.state.questionJDisabled} />),

                    },
                    {
                        case: 6,
                        cases: [6],
                        element: (advancedLearnerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 7,
                        cases: [7],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 8,
                        cases: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                        element: (/* Question F */<RuleSetQuestion key={805} trueQuestionState={9} falseQuestionState={14} name="universalCredit" value={this.props.model.universalCredit} question="Do you claim Universal Credit, disregarding Universal Credit and other benefits, and earn less than the relevant monthly threshold from paid employment?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionF} disabled={this.state.questionFDisabled} />),

                    },
                    {
                        case: 9,
                        cases: [9, 10, 11, 12, 13],
                        element: (/* Question G */<RuleSetQuestion key={806} trueQuestionState={10} falseQuestionState={11} name="universalCreditLowerIncome" value={this.props.model.universalCreditLowerIncome} question="Are you claiming an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionG} disabled={this.state.questionGDisabled} />),

                    },
                    {
                        case: 10,
                        cases: [10],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 11,
                        cases: [11, 12, 13],
                        element: (/* Question J */<RuleSetQuestion key={807} trueQuestionState={12} falseQuestionState={13} name="haveYouAppliedLl" value={this.props.model.haveYouAppliedLl} question="Have you applied for, or planning to apply for an Adult Loan?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionJ} disabled={this.state.questionJDisabled} />),

                    },
                    {
                        case: 12,
                        cases: [12],
                        element: (advancedLearnerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 13,
                        cases: [13],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 14,
                        cases: [14, 15, 16, 17, 18, 19, 20],
                        element: (/* Question H */<RuleSetQuestion key={808} trueQuestionState={15} falseQuestionState={16} name="jsaOrEsa" value={this.props.model.jsaOrEsa} question="Are you claiming Job Seekers Allowance (JSA) or Employment and Support Allowance (ESA)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionH} disabled={this.state.questionHDisabled} />),

                    },
                    {
                        case: 15,
                        cases: [15],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 16,
                        cases: [16, 17, 18, 19, 20],
                        element: (/* Question I */<RuleSetQuestion key={809} trueQuestionState={17} falseQuestionState={18} name="otherBenefitsLowIncome" value={this.props.model.otherBenefitsLowIncome} question="Are you claiming other Benefits with an earned income of less than �617 Per month or (�988 joint Income)?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionI} disabled={this.state.questionIDisabled} />),

                    },
                    {
                        case: 17,
                        cases: [17],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 18,
                        cases: [18, 19, 29],
                        element: (/* Question J */<RuleSetQuestion key={810} trueQuestionState={19} falseQuestionState={20} name="haveYouAppliedLl" value={this.props.model.haveYouAppliedLl} question="Have you applied for, or planning to apply for an Adult Loan?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionJ} disabled={this.state.questionJDisabled} />),

                    },
                    {
                        case: 19,
                        cases: [19],
                        element: (advancedLearnerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 20,
                        cases: [20],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 21,
                        cases: [21, 22, 23],
                        element: (/* Question J */<RuleSetQuestion key={811} trueQuestionState={22} falseQuestionState={23} name="haveYouAppliedLl" value={this.props.model.haveYouAppliedLl} question="Have you applied for, or planning to apply for an Adult Loan?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionJ} disabled={this.state.questionJDisabled} />),

                    },
                    {
                        case: 22,
                        cases: [22],
                        element: (advancedLearnerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 23,
                        cases: [23],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 24,
                        cases: [24],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset14
                [
                    {
                        case: 0,
                        cases: [0, 1, 2],
                        element: (/* Question E */<RuleSetQuestion key={1400} trueQuestionState={1} falseQuestionState={2} name="earnLessThan17K" value={this.props.model.earnLessThan17K} question={`Do you earn less than ${this.props.courseFees} annual gross ( before tax & NI ) salary?`} handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionE} disabled={this.state.questionEDisabled} />),

                    },
                    {
                        case: 1,
                        cases: [1],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 2,
                        cases: [2],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset15
                [
                    {
                        case: 0,
                        cases: [0, 1, 2, 3, 4],
                        element: (/* Question E */<RuleSetQuestion key={1500} trueQuestionState={1} falseQuestionState={2} name="earnLessThan17K" value={this.props.model.earnLessThan17K} question={`Do you earn less than ${this.props.courseFees} annual gross ( before tax & NI ) salary?`} handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionE} disabled={this.state.questionEDisabled} />),

                    },
                    {
                        case: 2,
                        cases: [2, 3, 4],
                        element: (/* Question J */<RuleSetQuestion key={1502} trueQuestionState={3} falseQuestionState={4} name="haveYouAppliedLl" value={this.props.model.haveYouAppliedLl} question="Have you applied for, or planning to apply for an Adult Loan?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionJ} disabled={this.state.questionJDisabled} />),

                    },
                    {
                        case: 1,
                        cases: [1],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 3,
                        cases: [3],
                        element: (advancedLearnerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 4,
                        cases: [4],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                ],
                // ruleset16
                [
                    {
                        case: 0,
                        cases: [0, 1, 2, 3, 4],
                        element: (/* Question B */ <RuleSetQuestion key={1600} trueQuestionState={1} falseQuestionState={4} name="completedL2OrAbove" value={this.props.model.completedL2OrAbove} question="Have you already completed a Full Level 2 or higher?" handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionB} disabled={this.state.questionBDisabled} />),

                    },
                    {
                        case: 1,
                        cases: [1, 2, 3],
                        element: (/* Question E */<RuleSetQuestion key={1601} trueQuestionState={2} falseQuestionState={3} name="earnLessThan17K" value={this.props.model.earnLessThan17K} question={`Do you earn less than ${this.props.courseFees} annual gross ( before tax & NI ) salary?`} handleQuestionChange={this.handleQuestionChange} setDisabled={this.disableQuestionE} disabled={this.state.questionEDisabled} />),

                    },
                    {
                        case: 2,
                        cases: [2],
                        element: (waiverMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 3,
                        cases: [3],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },
                    {
                        case: 4,
                        cases: [4],
                        element: (feePayerMessage),
                        displayAcceptance: true,
                    },

                ],
            ];

        return (
            <React.Fragment>




                <div className={classes.empty}></div>
                {
                    elements[this.props.ruleSetId].map((item, index) => {

                        if (item.cases.includes(this.state.questionState)) {
                            return (<React.Fragment key={index}>{item.element}</React.Fragment>)
                        }
                        return null;


                    })

                }

                {this.state.displayAcceptance &&
                    <React.Fragment>
                        <Grid item xs={12}>
                            <Typography>Please tick to indicate that you will provide any documents/proof of benefits requested, and you are aware that this calculator does not cover all personal situations and the answer provided here is only an indicator of any possible fee waivers, and is not guaranteed to apply.</Typography>
                        </Grid>
                        <Grid item xs={12} style={{ marginLeft: '10px' }}>

                            <RadioGroup
                                name="studentAcceptedFees"
                                value={this.props.model.studentAcceptedFees === undefined ? "false" : this.props.model.studentAcceptedFees.toString()}
                                onChange={this.handleAcceptanceChange}

                            //ref={(r) => { this.input = r; }}
                            >
                                <FormControlLabel value="true" control={<Radio />} label="Yes, I agree." />

                            </RadioGroup>
                        </Grid>
                    </React.Fragment>
                }
                {this.state.displayResetButton &&
                    <Grid item xs={12} style={{ marginLeft: '10px' }}><Button color="primary" variant="contained" className={classes.button} onClick={this.resetAnswers} fullWidth>Reset These Answers</Button></Grid>
                }
            </React.Fragment>
        )
    }
}

export default withStyles(styles)(FeeRuleSetsAdditional);

